import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bar-chart-fill",
  "use": "icon-bar-chart-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-bar-chart-fill\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bar-chart-fill\">\r\n  <rect width=\"4\" height=\"5\" x=\"1\" y=\"10\" rx=\"1\" />\r\n  <rect width=\"4\" height=\"9\" x=\"6\" y=\"6\" rx=\"1\" />\r\n  <rect width=\"4\" height=\"14\" x=\"11\" y=\"1\" rx=\"1\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bar-chart-fill.svg
// module id = LqtG
// module chunks = 60